import { createSelector } from 'reselect';

import { IBundleTile, mapBundlesToTiles } from '@/utility/mapSearchResultToTile';

import { TRootState } from '../rootReducer';
import { getUserFavorites } from './favorites';

type TBundlesData = TRootState['bundles'];
type TLoadingBundlesData = TRootState['bundles']['isLoading'];

export const getBundlesSelector = createSelector<
  TRootState,
  TBundlesData,
  ReturnType<typeof getUserFavorites>,
  IBundleTile[]
>(
  state => state.bundles,
  getUserFavorites,
  ({ data }, favorites) => {
    return mapBundlesToTiles({
      bundles: data || [],
      favorites,
    });
  },
);

export const getIsBundlesLoadingSelector = createSelector<TRootState, TLoadingBundlesData, boolean>(
  state => state.bundles.isLoading,
  data => data,
);
